import { Card } from '../../components/Card';
import { INote } from '../../notes/generic-notes/INote';
import { CheckinSavingQueueErrorToast } from './CheckinSavingQueueErrorToast';
import { NoteForm } from '../../notes/generic-notes/NoteForm';
import { CardHeading } from '../components/CardHeading';
import { ICheckin } from '../model/ICheckin';

export interface ICheckinNoteCardProps {
    checkin: ICheckin;
    heading?: string;
    onChange: (note: INote) => void;
}

export const CheckinNoteCard: React.FC<ICheckinNoteCardProps> = ({ checkin, heading, onChange }) => {
    return (
        <Card padded>
            <CardHeading>{heading || 'Note'}</CardHeading>
            {checkin &&
                <div data-type="checkin-note-editor" style={{display: 'flex', flexDirection: 'column', marginTop: -15, marginBottom: -20}}>
                    <CheckinSavingQueueErrorToast noteId={checkin.noteId}  />
                    <NoteForm
                        note={{
                            noteId: checkin.noteId,
                            title: '',
                            html: checkin.note || '',
                            attachments: checkin.attachments || [],
                            tags: checkin.tags || []
                        }}
                        canEdit
                        includeTemplates
                        noteTarget={{section: 'checkin', checkinType: checkin.checkinType}}
                        noteChanged={onChange}
                    />
                </div>
            }
        </Card>
    );
};
